import { BLOCK_TYPES } from '../blocks/types.js';
import { SERVICE_CATALOG, servicePath } from '../../navigation/serviceCatalog.js';

// Service Content — Business Chauffeur (golden pattern: airport-transfer / station-transfer, PR #250/#251).
// Authored FRENCH content from existing Content-Platform blocks + VERIFIED facts already live on the site:
//   - déplacements professionnels / rendez-vous d'affaires  (locales: services.business "Rendez-vous d'affaires")
//   - mise à disposition sur une journée business           (locales: services "Mise à disposition … journées business")
//   - chauffeurs professionnels, ponctualité, discrétion, confort, fixed price, online booking, 24/7
//   - SAB area (Nantes + Angers/Rennes/La Roche-sur-Yon); airport/gare are live sibling services
// OPERATIONAL-RISK GUARD: this is a TRANSPORT service page. It makes NO hard B2B promises — no enterprise
// contracts, NO monthly invoicing, NO dedicated account manager, NO priority service, NO guaranteed/
// dedicated chauffeur availability. Those B2B account features live on the /entreprises page; the CTA
// links there generically ("Solutions entreprises") rather than restating them as promises here.
// Vehicles BRAND-NEUTRAL (no Mercedes/E-Class/V-Class). No fabricated claims (reviews/ratings/stats/
// awards/certifications/partnerships). Presentation copy only. Mesh derived from the ratified catalogue.

const SLUG = 'business-chauffeur';
const siblings = SERVICE_CATALOG
  .filter((s) => s.slug !== SLUG)
  .map((s) => ({ label: s.name, to: servicePath(s.slug) }));

export default {
  blocks: [
    {
      type: BLOCK_TYPES.HERO,
      kicker: 'Chauffeur privé premium',
      title: 'Chauffeur d’affaires à Nantes',
      lead:
        'Un chauffeur privé pour vos déplacements professionnels à Nantes et en Loire-Atlantique — ponctuel, discret et au tarif fixe connu à l’avance.',
    },
    {
      type: BLOCK_TYPES.INTRO,
      text:
        'Black Matte accompagne vos rendez-vous d’affaires et déplacements professionnels à Nantes et en Loire-Atlantique, avec des véhicules haut de gamme et un service ponctuel et discret, réservable en ligne 24h/24, 7j/7.',
    },
    {
      type: BLOCK_TYPES.RICH_TEXT,
      heading: 'Pourquoi réserver un chauffeur d’affaires avec Black Matte',
      body: [
        'Un déplacement professionnel demande ponctualité et sérénité. Avec un chauffeur privé, vous arrivez à l’heure à vos rendez-vous, sans gérer le stationnement ni l’itinéraire, et vous mettez le trajet à profit pour préparer une réunion ou passer vos appels.',
        'Le tarif est fixe et communiqué avant la réservation. Vous voyagez à bord d’un véhicule haut de gamme, confortable et soigné, conduit par un chauffeur privé professionnel et discret — pour une image à la hauteur de vos rendez-vous d’affaires.',
      ],
    },
    {
      type: BLOCK_TYPES.FEATURE_GRID,
      heading: 'Un service pensé pour les professionnels',
      items: [
        { title: 'Ponctualité', text: 'Une prise en charge à l’heure, pour vos rendez-vous et vos réunions.' },
        { title: 'Discrétion', text: 'Un service professionnel et confidentiel, propice au travail comme aux échanges.' },
        { title: 'Confort', text: 'Un véhicule haut de gamme, calme et soigné, pour voyager ou préparer vos rendez-vous.' },
        { title: 'Réservation simple', text: 'Réservez en ligne en quelques minutes, avec un tarif fixe connu à l’avance.' },
      ],
    },
    {
      type: BLOCK_TYPES.STEPS,
      heading: 'Comment réserver votre trajet professionnel',
      steps: [
        { title: 'Indiquez votre trajet', text: 'Renseignez vos adresses, la date et l’heure de votre déplacement professionnel.' },
        { title: 'Obtenez votre tarif fixe', text: 'Votre prix est calculé et communiqué avant de confirmer la réservation.' },
        { title: 'Confirmez en ligne', text: 'Validez votre réservation en quelques minutes, directement en ligne.' },
        { title: 'Votre chauffeur vous accompagne', text: 'Votre chauffeur vous prend en charge à l’heure, à l’aller comme au retour.' },
      ],
    },
    {
      type: BLOCK_TYPES.RICH_TEXT,
      heading: 'Le déplacement professionnel à Nantes et en Loire-Atlantique',
      body: [
        'Qu’il s’agisse d’un rendez-vous d’affaires, d’un transfert vers l’aéroport de Nantes Atlantique ou la gare, ou d’une mise à disposition sur une journée, Black Matte assure vos déplacements professionnels à Nantes et dans toute la Loire-Atlantique.',
        'Notre service couvre Nantes et sa région, ainsi qu’Angers, Rennes et La Roche-sur-Yon, 24h/24 et 7j/7. Pour les entreprises, des solutions dédiées permettent de simplifier les déplacements de vos collaborateurs.',
      ],
    },
    {
      type: BLOCK_TYPES.CTA,
      heading: 'Réservez votre chauffeur d’affaires',
      text: 'Réservez votre chauffeur pour vos déplacements professionnels, ou découvrez nos solutions pour les entreprises.',
      actions: [
        { label: 'Réserver', to: '/reserver' },
        { label: 'Solutions entreprises', to: '/entreprises' },
      ],
    },
    {
      type: BLOCK_TYPES.RELATED_CONTENT,
      heading: 'Autres prestations',
      links: siblings,
    },
  ],
};
